// SPDX-License-Identifier: Elastic-2.0
/**
 * SidebarSection — labelled group of `<SidebarItem>`s.
 *
 * Renders a Manrope eyebrow title (tracked-uppercase) followed by the
 * children stacked vertically. The title is hidden visually when the parent
 * `<Sidebar collapsed>` is set, but the section remains as a structural
 * container for assistive tech.
 */
import type { HTMLAttributes, ReactNode } from "react";

import styles from "./Sidebar.module.css";

export interface SidebarSectionProps extends HTMLAttributes<HTMLDivElement> {
  /** Section heading (e.g. "Hogar", "Cuenta", "Avanzado"). */
  title: string;
  children?: ReactNode;
}

export function SidebarSection({
  title,
  className,
  children,
  ...rest
}: SidebarSectionProps): JSX.Element {
  const composed = [styles.section, className].filter(Boolean).join(" ");
  return (
    <div className={composed} role="group" aria-label={title} {...rest}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      <div className={styles.sectionItems}>{children}</div>
    </div>
  );
}
